import { session } from "utils/storage";

const UTM_PARAMS = [
  { key: "utmCampaign", searchParam: "utm_campaign" },
  { key: "utmSource", searchParam: "utm_source" },
  { key: "utmMedium", searchParam: "utm_medium" },
];

const storeUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmParams = session.getItem("utmParams") || {};
  const newUtmParams = UTM_PARAMS.reduce((acc, { key, searchParam }) => {
    const value = params.get(searchParam);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, utmParams);

  session.setItem("utmParams", newUtmParams);
};

export default storeUtmParams;
